import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import useTranslationDashboard from "../useTranslationDashboard.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import PageSubtitle from "../../common/widgets/PageSubtitle.js";
import "./SponsorshipItem.scss";
import useQuerySponsoredRecruiterCount from "./useQuerySponsoredRecruiterCount.js";
import ActionLink from "../../common/widgets/ActionLink.js";
import StringUtils from "../../../utils/StringUtils.js";
import * as ROUTES from "../../../constants/routes.js";
import useReferrer from "../../infra-no-ui/navigation/useReferrer.js";

export default function SponsorshipItem(props) {
  const { recruiterId } = props;

  const { t, loading: tLoading } = useTranslationDashboard();
  useShowLoader(tLoading, "SponsorshipItem");

  const {
    data: recruiter,
    loading,
    errors,
  } = useQuerySponsoredRecruiterCount(recruiterId);

  const {redirectTo} = useReferrer();

  const goToProgramDetails = () => {
    redirectTo(ROUTES.SPONSORSHIP);
  }

  const goToSponsoredList = () => {
    redirectTo(ROUTES.SPONSORED);
  }

  const sponsoredCountMessage =
    <>
      <span>{t("dashboard:recruiters_dashboard_sponsorship_sponsoring_label")}</span>
      <ActionLink onClick={goToSponsoredList} className={"spotter-count"}>{t("dashboard:recruiters_dashboard_sponsorship_count_label", {count: StringUtils.nullToZero(recruiter && recruiter.sponsoredRecruiterCount)})}</ActionLink>
    </>;

  const programDetailsMessage = <ActionLink onClick={goToProgramDetails}>{t("dashboard:recruiters_dashboard_sponsorship_details_label")}</ActionLink>;
  const startSponsoringMessage =
    <>
      <ActionLink onClick={goToProgramDetails}>{t("dashboard:recruiters_dashboard_sponsorship_start_label")}</ActionLink><br/>
      <span>{t("dashboard:recruiters_dashboard_sponsorship_revenue_label")}</span>
    </>;

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <div className="SponsorshipItem">
            <Row>
              <Col className="hired-candidates">
                <PageSubtitle colTitle={t("dashboard:recruiters_dashboard_sponsorship_title")} />
              </Col>
            </Row>
            <Row>
              <Col className="sponsor-stats">
                {sponsoredCountMessage}
              </Col>
            </Row>
            <Row className="program-details">
              <Col>
                {recruiter.sponsoredRecruiterCount ? programDetailsMessage : startSponsoringMessage}
              </Col>
            </Row>
          </div>
        )}
      />
    </HorizontalLoader>
  );
}
